/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 * @since v0.1.0
 * @param  a
 * @param  b
 * @return
 */
 const and=(a:boolean, b:boolean):boolean => a && b;
export default and;



// WEBPACK FOOTER //
// ./src/and.ts